module.exports = {
  message: {
    home_pro_title: 'Product Authentication',
    home_verify_title: 'To verify your product, you can either:',
    home_button_scan: 'Use your phone\'s camera to scan',
    home_button_file: 'Choose your AB Code Photo',
    home_button_app: 'Download IVPS Tour APP',
    home_qr_text: 'Where can you find the AB code?',
    home_find_title: 'Find the "Code A" on product\'s package, as per the photo as follows.',
    home_use_title: 'Use your phone\'s camera to scan the Code A or choose Code A photo in your album.',
    home_fake_title: 'How to identify authenticity of my product?',
    home_modal_hint: 'Please allow us to access your camera to bind the product',
    home_modal_OK: 'OK',
    home_model_not_scanner_code_a: 'Unable to scan Code A, please make sure the picture is clear.',
    A_activate_hint: 'Product:',
    A_activate_cur: 'The current state of the product',
    A_activate_act: 'Activated',
    A_activate_act_hint: 'Activation ',
    A_activate_bind_email: 'Activation email address: {email}',
    A_activate_bind_device: 'Activation device ID: {device}',
    A_activate_purchase: 'If it is not activated by you, please do not purchase.',
    A_activate_report: 'Report inferior merchants',
    A_activate_device: 'device ',
    A_activate_email: 'email address ',
    A_fake_counterfeits: 'Report counterfeits',
    A_nonactivate_prohint: 'Product:',
    A_nonactivate_SNhint: 'SN:',
    A_nonactivate_cur: 'The current state of the product',
    A_nonactivate_act: 'Not activated',
    A_nonactivate_time: 'The product Code A has been scanned {count} times.',
    A_nonactivate_time_1: 'times',
    A_nonactivate_btn: 'Activate the product',
    A_nonactivate_scan: 'Scan Code B',
    B_bind_prohint: 'The product is authentic.',
    B_bind_email: 'Please enter your email address to bind the product',
    B_bind_addr: 'Please use a real email address to make sure this product is owned by yourself.',
    B_bind_btn: 'Bind the product',
    B_fake_fail: 'Binding failed!',
    B_fake_scan: 'Please provide the correct Code B',
    home_model_not_scanner_code_b: 'Unable to scan Code B, please make sure the picture is clear.',
    B_fake_btn_scan: 'Rescan the Code B',
    inform_input_name: 'Name(Required)',
    inform_input_email: 'E-mail(Required)',
    inform_input_number: 'Phone number(Required)',
    inform_input_store_name: 'Store Name & Website',
    inform_input_store_address: 'Store address',
    inform_input_feedback: 'Feedback content(Required)',
    inform_input_submit: 'Submit',
    A_query_result: 'Query Results',
    success: 'Success',
    success_content: {
      'bind': 'Binding success',
      'activate': 'Activation success'
    },
    error: 'Failed',
    copy_a_success: 'Copy Code A Success',
    copy_a_fail: 'Copy Code A Failed',
    home_title:'Start your IVPS Tour',
    tipText:'Align QR code within the frame to scan',
    Back:'Back',
    Copy_security_code: 'Copy Security Code',
    switch_language:'Switch Language',
    a_black_text:'This product is confirmed as a fake. Buying this product may cause a safety accident and seriously endanger the life and health of you and the people around you. Please do not buy.'
  },
  "Warning": {
    "WARNING": "WARNING",
    "slogan": "This product is intended to be used with e-liquid products containing nicotine. Nicotine is an addictive chemical.",
    "safety": "Important Safety Information and Warnings",
    "age": "You have to make sure that your age is 21 or older, then you can download this application. Otherwise, please leave and close this page immediately!",
    "UNDER": "UNDER"
},
}